import React, {useEffect} from 'react';
import {useField} from 'formik';
import {useDispatch, useSelector} from 'react-redux';

import {CourseOption, getCourseOptionsSelector, getCourseList} from 'src/redux/lists';
import {Store} from 'src/types/store';
import {EducationPhase} from 'src/types/enums';

import Label from 'shared/components/label';
import AccessibleTypeahead from 'shared/components/accessible-typeahead';
import {CourseForm} from './course-form-wrapper';
import {ButtonSizes} from 'shared/constants';

interface Props {
  className?: string;
  size?: ButtonSizes;
  prefix?: string;
}

let hasRequestedCourses = false;

const CourseNameTypeahead = ({className, size = 'medium', prefix = ''}: Props) => {
  const dispatch = useDispatch();
  const [courseTypeField] = useField<CourseForm['courseType']>(`${prefix}courseType`);
  const [nameField, _nameMeta, nameHelpers] = useField<CourseForm['name']>(`${prefix}name`);
  const [_subjectField, _subjectMeta, subjectHelpers] = useField<CourseForm['subject']>(
    `${prefix}subject`
  );
  const [newField] = useField<CourseForm['new']>(`${prefix}new`);

  const courseOptions = useSelector((state: Store) =>
    getCourseOptionsSelector(state, courseTypeField.value)
  );

  useEffect(() => {
    if (!courseOptions?.length && !hasRequestedCourses) {
      hasRequestedCourses = true;
      dispatch(getCourseList(EducationPhase.HIGH_SCHOOL));
    }
  }, [dispatch, courseOptions]);

  return (
    <Label className={className} required>
      Course Name
      <AccessibleTypeahead
        id="bulk-entry-course-name-typeahead"
        {...nameField}
        focusOnMount={!prefix && newField.value}
        onInputChange={(course: CourseOption) => nameHelpers.setValue(course.text)}
        onBlur={(e) => nameHelpers.setValue(e.target.value)}
        onSelect={(course: CourseOption) => {
          nameHelpers.setValue(course.text);

          if (course.subject) {
            subjectHelpers.setValue(course.subject);
          }
        }}
        options={courseOptions}
        placeholder="Course name"
        allowNew
        required={prefix ? !newField.value : true}
        size={size}
        cy="bulk-entry-course-name-typeahead"
      />
    </Label>
  );
};

export default CourseNameTypeahead;
